import React from 'react';
import { EOrderTab } from '../../../../store/ducks/long-steel-orders/types';
import { Modal } from '@gerdau/hefesto';

import {
  ModalOverlay,
  UpdateItemsAllowedText,
  UpdateItemsContainer,
  UpdateItemsWrapper
} from './styles';
import {
  ITypeActionKey,
  SalesOrderItem,
  typeActionDicionary
} from '../../../../store/ducks/new-long-steel-orders/types';
import { useLocation } from 'react-router-dom';
import { updateQueryParam } from '../../../../utils/updateQueryParams';
import { history } from '../../../../hooks/history';
import { ENewLongSteelOrdersRoutes } from '..';
import { useDispatch, useSelector } from 'react-redux';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import { ApplicationState } from '../../../../store';
import moment from 'moment';

export const UpateItemsUnavailable = ({
  items,
  itemsAllowedLength = 0,
  type
}: {
  items: SalesOrderItem[];
  itemsAllowedLength?: number;
  type: ITypeActionKey;
}) => {
  const dispatch = useDispatch();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const notallowed = params.get(type) === 'notallowed';
  const withoutItems = params.get('type') === 'withoutitems';

  if (!notallowed || !items) {
    return null;
  }

  const ordersState = useSelector(
    (state: ApplicationState) => state.newLongSteelOrders
  );

  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );

  const handleClose = () => {
    updateQueryParam(type);
    updateQueryParam('type');

    dispatch(
      sendTagging({
        event:
          type === 'cancel'
            ? 'modal_solicitar_cancelamento_indisponivel'
            : 'modal_solicitar_alteracoes_indisponivel',
        click: 'cancelar',
        screenName: 'LG:MeusPedidos',
        itemDescription: 'meus_pedidos_acosLongos',
        estado_emissor:
          ordersState[
            ordersState.tableType || EOrderTab.OPEN
          ].initialInputValues.states.join(', '),
        emissor_pedido: customersState.customers
          .filter((item) =>
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.emitterIds.includes(item.customerId)
          )
          .map((item) => item.name)
          .join(', '),
        data_inicio: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.startDate
        ).format('DD/MM/YYYY'),
        data_fim: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.endDate
        ).format('DD/MM/YYYY')
      })
    );
  };

  const handleContinue = () => {
    updateQueryParam(type);
    if (type === 'update') {
      history.push(
        `${history.location.pathname}${ENewLongSteelOrdersRoutes.UPDATE}`
      );
      return;
    }
    updateQueryParam(type, 'progress');

    dispatch(
      sendTagging({
        event:
          type === 'cancel'
            ? 'modal_solicitar_cancelamento_indisponivel'
            : 'modal_solicitar_alteracoes_indisponivel',
        click: 'continuar',
        screenName: 'LG:MeusPedidos',
        itemDescription: 'meus_pedidos_acosLongos',
        estado_emissor:
          ordersState[
            ordersState.tableType || EOrderTab.OPEN
          ].initialInputValues.states.join(', '),
        emissor_pedido: customersState.customers
          .filter((item) =>
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.emitterIds.includes(item.customerId)
          )
          .map((item) => item.name)
          .join(', '),
        data_inicio: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.startDate
        ).format('DD/MM/YYYY'),
        data_fim: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.endDate
        ).format('DD/MM/YYYY')
      })
    );
  };

  return (
    <ModalOverlay width={564}>
      <Modal
        title={`‘${typeActionDicionary[type]}’ está indisponível para ${
          items.length > 1 ? `${items.length} produtos` : `1 produto`
        }`}
        modalSize="sm"
        buttons={
          withoutItems
            ? {
                right: {
                  name: 'button-close-unavailable-items-update',
                  children: 'Voltar',
                  onClick: handleClose,
                  type: 'button'
                }
              }
            : {
                left: {
                  name: 'button-close-unavailable-items-update',
                  children: 'Cancelar',
                  onClick: handleClose,
                  type: 'button'
                },
                right: {
                  name: 'button-continue-unavailable-items-update',
                  children: 'Continuar',
                  onClick: handleContinue,
                  type: 'button',
                  ...(type === 'cancel' && { variant: 'danger' })
                }
              }
        }
      >
        <UpdateItemsContainer>
          <span>
            Alguns produtos não podem ser{' '}
            {type === 'cancel' ? 'cancelados' : 'alterados'} porque estão em
            remessa ou são de um tipo que não permite modificações.
          </span>
          <UpdateItemsWrapper>
            {items.map((item) => (
              <span key={`${item.sku} - ${item.materialDescription}`}>
                {item.sku} - {item.materialDescription}
              </span>
            ))}
          </UpdateItemsWrapper>
          {itemsAllowedLength > 0 && (
            <UpdateItemsAllowedText>
              Deseja solicitar{' '}
              {type === 'cancel' ? 'o cancelamento' : 'alterações'}{' '}
              {itemsAllowedLength > 1
                ? `dos outros
              ${itemsAllowedLength} produtos?`
                : 'do outro produto?'}
            </UpdateItemsAllowedText>
          )}
        </UpdateItemsContainer>
      </Modal>
    </ModalOverlay>
  );
};
